import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { resilienceApi, type RTOMetrics, type RPOMetrics } from '../../api/resilience';

export function DisasterRecoveryConsolePage() {
  const [rto, setRto] = useState<RTOMetrics | null>(null);
  const [rpo, setRpo] = useState<RPOMetrics | null>(null);
  useEffect(() => { void resilienceApi.rto().then(setRto); void resilienceApi.rpo().then(setRpo); }, []);
  return (
    <div className="mx-auto max-w-6xl p-6">
      <h1 className="text-2xl font-semibold dark:text-slate-100">Disaster Recovery Console</h1>
      <Link to="/resilience" className="mt-2 inline-block text-sm text-emerald-700 hover:underline dark:text-emerald-400">← Resilience Hub</Link>
      <div className="mt-6 grid gap-4 sm:grid-cols-2">
        <div className="rounded-xl border p-4 dark:border-slate-700"><h2 className="font-medium">RTO</h2>{rto && <p className="mt-2 text-sm">Current: {rto.current_seconds}s / Target: {rto.target_seconds}s · {rto.within_target ? 'Within target' : 'Exceeds target'}</p>}</div>
        <div className="rounded-xl border p-4 dark:border-slate-700"><h2 className="font-medium">RPO</h2>{rpo && <p className="mt-2 text-sm">Current: {rpo.current_seconds}s / Target: {rpo.target_seconds}s · Backup lag: {rpo.last_backup_lag_seconds}s</p>}</div>
      </div>
    </div>
  );
}
